// Import External Libraries
import React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { I18n } from 'react-i18next';

import Header from '../Components/Globals/Header/HeaderController';
import Footer from '../Components/Globals/Footer/FooterController';
import Loader from '../Components/Globals/Loader/LoaderController';
import HomeView from '../Views/HomeView/HomeView';
import ArticleView from '../Views/ArticleView/ArticleView';
import ErrorView from '../Views/ErrorView/ErrorView';
import AmbassadorsView from '../Views/AmbassadorsView/AmbassadorsView';
import AmbassadorDetailView from '../Views/AmbassadorDetailView/AmbassadorDetailView';
import ImagePlayer from '../Components/Globals/ImagePlayer/ImagePlayer';


export default (
  <I18n>
    {t => (
      <Router basepath={`/${process.env.LENSPIRE_CHANNEL}`}>
        <div>
          <ImagePlayer />
          <Loader />
          <Header />
          <Switch>
            <Route path={`/${process.env.LENSPIRE_CHANNEL}/:lang/${t('translations.article')}/:article`} component={ArticleView} />
            <Route exact path={`/${process.env.LENSPIRE_CHANNEL}/:lang/${t('translations.ambassadors')}/`} component={AmbassadorsView} />
            <Route path={`/${process.env.LENSPIRE_CHANNEL}/:lang/${t('translations.ambassadors')}/:ambassador`} component={AmbassadorDetailView} />
            <Route path={`/${process.env.LENSPIRE_CHANNEL}/:lang/${t('translations.filter')}/`} component={HomeView} />
            <Route exact path={`/${process.env.LENSPIRE_CHANNEL}/:lang/category/:category`} component={HomeView} />
            <Route exact path={`/${process.env.LENSPIRE_CHANNEL}/:lang/search/:search`} component={HomeView} />
            <Route exact path={`/${process.env.LENSPIRE_CHANNEL}/:lang/author/:author`} component={HomeView} />
            <Route exact path={`/${process.env.LENSPIRE_CHANNEL}/:lang`} component={HomeView} />
            <Redirect from={`/${process.env.LENSPIRE_CHANNEL}/`} exact to={`/${process.env.LENSPIRE_CHANNEL}/en/`} />
            <Route component={ErrorView} />
          </Switch>
          <Footer />
        </div>
      </Router>
    )}
  </I18n>
);



// WEBPACK FOOTER //
// ./frontend/js/Base/Router.jsx